import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { activateColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getActivate } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "msisdn", "last_updated"];

const OPNActivateBatch = () => (
  <BatchDetail
    title="OPN Activate"
    apiGet={__getActivate}
    client={CLIENTS.opn}
    columnsFactory={activateColumns}
    copyKeys={COPY_KEYS}
    exportAction="activate"
    retryOperation="activate"
    showCheckStatus
    checkStatusOperation="activate"
    showTerminate
    getRowPath={(row) => `/opn/activate/${row.id}`}
  />
);

export default OPNActivateBatch;
